import { Badge } from "@/components/ui/Badge";

type RentStatus = "PENDING" | "PAID" | "AWAITING_VERIFICATION" | "OVERDUE";

interface RentStatusBadgeProps {
  status: RentStatus;
}

export function RentStatusBadge({ status }: RentStatusBadgeProps) {
  const config: Record<RentStatus, { variant: "success" | "warning" | "danger" | "neutral"; label: string }> = {
    PAID: { variant: "success", label: "Paid" },
    PENDING: { variant: "warning", label: "Pending" },
    AWAITING_VERIFICATION: { variant: "neutral", label: "Awaiting" },
    OVERDUE: { variant: "danger", label: "Overdue" },
  };

  const { variant, label } = config[status] ?? { variant: "neutral" as const, label: status };

  return <Badge variant={variant}>{label}</Badge>;
}
